import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../button/button';

type Props = {
  color: Parameters<typeof Button>[0]['color'];
  disabled?: boolean;
  variant: Parameters<typeof Button>[0]['variant'];
};

const GoToLoginPageButton = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      color={props.color}
      disabled={props.disabled}
      type="button"
      variant={props.variant}
      onClick={() => navigate('/signin')}
    >
      {t('goToLoginPage', { ns: 'common' })}
    </Button>
  );
};

export { GoToLoginPageButton };
